import { Controller } from "stimulus"
const EMAIL_REGEX = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i

export default class extends Controller {
  connect() {
    this.initializeFormValidation();
    this.boxControls();
    let sendEmailVerificationBtn = document.getElementById("send-email-verification-btn")
    sendEmailVerificationBtn.addEventListener("click", ()=> this.sendEmailVerification(sendEmailVerificationBtn))
    let verifyEmailBtn = document.getElementById("verify-email-btn")
    verifyEmailBtn.addEventListener("click", () => this.otpVerification(verifyEmailBtn))
    this.toggleEin()
    document.querySelectorAll('input[name="agent_signup[is_us_taxpayer]"]').forEach(radio => {
      radio.addEventListener("change", () => this.togglesTaxInfos())
    })
    this.element.addEventListener("submit", (event) => {
      setTimeout(() => {
        if (event.defaultPrevented) {
          this.hidePreparingOverlay()
          return
        }
        this.showPreparingOverlay()
      }, 0)
    })
  }
  initializeFormValidation() {
    let successToken = document.getElementById("success_token");
    if (successToken.value.trim()) {
      let sendEmailVerificationBtn = document.getElementById("send-email-verification-btn");
      this.setButtonLoading(sendEmailVerificationBtn, "Verified", { keepDisabled: true, showSpinner: false })
    }
  }

  showPreparingOverlay() {
    const overlay = document.getElementById("agent-signup-loading-overlay")
    if (overlay) {
      overlay.classList.remove("d-none")
      document.body.style.overflow = "hidden"
    }
    const submitBtn = this.element.querySelector('input[type="submit"], button[type="submit"]')
    if (submitBtn) submitBtn.disabled = true
  }

  hidePreparingOverlay() {
    const overlay = document.getElementById("agent-signup-loading-overlay")
    if (overlay) {
      overlay.classList.add("d-none")
      document.body.style.overflow = ""
    }
    const submitBtn = this.element.querySelector('input[type="submit"], button[type="submit"]')
    if (submitBtn) submitBtn.disabled = false
  }

  boxControls() { 
    let box3a = document.getElementById("agent_signup_box_3a")
    let box3a_llc_classification = document.getElementById("agent_signup_box_3a_llc_classification")
    this.box3aLlc(box3a);
    this.box3aOtherValue(box3a);
    this.box3bCheckbox(box3a);
    box3a.addEventListener("change", () => {
      this.box3aLlc(box3a)
      this.box3aOtherValue(box3a)
      this.box3bCheckbox(box3a)
    })
    box3a_llc_classification.addEventListener("change", () => {
      this.box3bCheckbox(box3a)
    })
  }

  box3bCheckbox(box3a) { 
    let box3b_checkbox_container = document.getElementById("box_3b_checkbox_container");
    let box3b_checkbox = document.getElementById("agent_signup_box_3b_checkbox")
    let box3a_llc_classification = document.getElementById("agent_signup_box_3a_llc_classification")
    if ((box3a.value === "llc" && box3a_llc_classification.value === "p") || (box3a.value === "partnership") || (box3a.value === "trust_or_estate")) {
      box3b_checkbox_container.classList.remove("d-none")
    } else {
      box3b_checkbox_container.classList.add("d-none")
      box3b_checkbox.checked = false
    }
  }

  box3aOtherValue(box3a) { 
    let box3a_other_value_container = document.getElementById("box_3a_other_value_container")
    let box3a_other_value = document.getElementById("agent_signup_box_3a_other_value")
    if (box3a.value === "other") {
      box3a_other_value_container.classList.remove("d-none")
    } else {
      box3a_other_value_container.classList.add("d-none")
      box3a_other_value.value = ""
    }
  }

  box3aLlc(box3a) { 
    let box3a_llc_classification = document.getElementById("agent_signup_box_3a_llc_classification")
    let box3a_llc_classification_container = document.getElementById("box_3a_llc_classification_container")
    if (box3a.value === "llc") {
      box3a_llc_classification_container.classList.remove("d-none")
    } else {
      box3a_llc_classification_container.classList.add("d-none")
      box3a_llc_classification.value = ""
    }
  }

  togglesTaxInfos() {
    this.toggleNonUsTaxDocument()
    this.toggleEin()
  }

  toggleNonUsTaxDocument() {
    let isUsTaxpayer = document.querySelector('input[name="agent_signup[is_us_taxpayer]"]:checked').value
    if (isUsTaxpayer === "false") {
      document.querySelector(".agent_signup_non_us_tax_document_pdf").classList.remove("d-none")
    } else {
      document.querySelector(".agent_signup_non_us_tax_document_pdf").classList.add("d-none")
    }
  }

  toggleEin() { 
    let isUsTaxpayer = document.querySelector('input[name="agent_signup[is_us_taxpayer]"]:checked').value
    if (isUsTaxpayer === "true") {
      document.querySelector(".agent_signup_ein").classList.remove("d-none")
    } else {
      document.querySelector(".agent_signup_ein").classList.add("d-none")
    }
  }

  sendEmailVerification(sendEmailVerificationBtn) {
    this.setButtonLoading(sendEmailVerificationBtn, "Sending...")
    let email = document.getElementById("agent_signup_email").value.trim()
    if (!this.validEmail(email)) { 
      this.clearButtonLoading(sendEmailVerificationBtn)
    }
    
    fetch(`/agent_signup/email_verification?email=${email}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        this.clearButtonLoading(sendEmailVerificationBtn)
        console.error(data.error)
        alert(data.error)
      } else {
        this.setButtonLoading(sendEmailVerificationBtn, "Sent", { keepDisabled: true, showSpinner: false })
        setTimeout(() => {
          this.clearButtonLoading(sendEmailVerificationBtn)
        }, 120000)
        let verificationCodeContainer = document.getElementById("verification_code_container")
        verificationCodeContainer.classList.remove("d-none")
      }
    });
  }

  otpVerification(otpVerificationBtn) {
    this.setButtonLoading(otpVerificationBtn, "Verifying...");
    let successToken = document.getElementById("success_token");
    let code = document.getElementById("verification_code").value.trim();
    let email = document.getElementById("agent_signup_email").value.trim();
    if (!this.validEmail(email) && code.length !== 6) {
      this.clearButtonLoading(otpVerificationBtn)
      alert("Please enter a valid email and verification code.")
      return
    }
    fetch(`/agent_signup/email_otp_verification?email=${email}&code=${code}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        this.clearButtonLoading(otpVerificationBtn)
        alert(data.error)
      }
      else {
        this.setButtonLoading(otpVerificationBtn, "Verified", { keepDisabled: true, showSpinner: false })
        successToken.value = data.success_token
      }
    });
  }


  validEmail(email) {
    return EMAIL_REGEX.test(email.trim())
  }

  setButtonLoading(button, label, { keepDisabled = true, showSpinner = true } = {}) {
    if (!button.dataset.originalHtml) {
      button.dataset.originalHtml = button.innerHTML
    }
    button.disabled = keepDisabled
    if (showSpinner) {
      button.innerHTML = `
        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        ${label}
      `
    } else {
      button.textContent = label
    }
  }

  clearButtonLoading(button, label = "Verify") {
    button.disabled = false
    button.innerHTML = button.dataset.originalHtml || label
  }
}